/**
 * Core / Plugin: Component states
 * -----------------------------------------------------------------------------
 * Vue plugin to extend Vue instance with component methods.
 *
 */
import { mapActions, mapGetters } from 'vuex'

import { convertToHandle } from '~/helpers/convert'

/**
 * Expose install method.
 */
export default {
  install: (app) => {
    app.mixin({
      computed: {

        /**
         * Map Vuex getters.
         */
        ...mapGetters({
          getActiveComponents: 'components/getActive',
          getVisibleComponents: 'components/getVisible',
        }),
      },

      mounted() {
        const excludedComponents = [
          'async-component-wrapper',
          'base-transition',
        ]

        const handle = convertToHandle(this.$options.name)

        /**
         * Do not push state of global or default Vue components.
         */
        if (this.global || excludedComponents.includes(handle)) {
          return
        }

        this.setComponentState({ handle, state: cnvs.states.active })
      },

      methods: {

        /**
         * Map Vuex actions.
         */
        ...mapActions({
          loadComponent: 'components/load',
          setComponentState: 'components/setState',
          setComponentStates: 'components/setStates',
        }),

        /**
         * Get component active state.
         * - Returns true if component has state `active`.
         * @param {String} handle - Component handle.
         * @returns {Boolean}
         */
        getComponentActive(handle) {
          return this.getActiveComponents.includes(handle)
        },

        /**
         * Get component visible state.
         * - Returns true if component has state and it's not `waiting`.
         * @param {String} handle - Component handle.
         * @returns {Boolean}
         */
        getComponentVisible(handle) {
          return this.getVisibleComponents.includes(handle)
        },
      },
    })
  },
}
